import { isValid, isBefore } from 'date-fns'
import { TFunction } from 'i18next'
import { z } from 'zod'
import { TARIFF_NAME_MAX_CHAR } from '../components/add-tariff/AddTariffForm'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/explicit-function-return-type
export const createEditTariffSchema = (t: TFunction) =>
  z
    .object({
      tariffId: z.string(),
      tariffName: z
        .string({ required_error: t('emobility.tariffs.nameRequired') })
        .min(1, t('emobility.tariffs.nameRequired'))
        .max(TARIFF_NAME_MAX_CHAR, t('emobility.tariffs.nameToLong')),
      tariffGridPrice: z
        .string({ required_error: t('emobility.tariffs.priceRequired') })
        .min(1, t('emobility.tariffs.priceRequired'))
        .refine(v => !Number.isNaN(Number(v)), { message: t('emobility.tariffs.mustBeNumber') }),
      tariffSolarPrice: z
        .string()
        .nullable()
        .refine(v => v === null || v === '' || !Number.isNaN(Number(v)), {
          message: t('emobility.tariffs.mustBeNumber'),
        }),
      tariffDischargePrice: z
        .string()
        .nullable()
        .refine(v => v === null || v === '' || !Number.isNaN(Number(v)), {
          message: t('emobility.tariffs.mustBeNumber'),
        }),
      startDate: z
        .string()
        .nullable()
        .refine(v => v === null || isValid(new Date(v)), {
          message: t('emobility.tariffs.validDateFormat'),
        }),
      endDate: z
        .string()
        .nullable()
        .refine(v => v === null || isValid(new Date(v)), {
          message: t('emobility.tariffs.validDateFormat'),
        }),
      currencyCode: z.string(),
    })
    .refine(
      data => {
        /** it makes sense to validate start and end date against each other only when both have an actual value */
        if (!data.startDate || !data.endDate) {
          return true
        }

        const start = new Date(data.startDate)
        const end = new Date(data.endDate)

        return isBefore(start, end)
      },
      {
        message: t('emobility.tariffs.validEndDate'),
        path: ['endDate'],
      }
    )

export type EditTariffFormData = z.infer<ReturnType<typeof createEditTariffSchema>>
